export class RequestData {
    number: string;
    guid: string;
}